export default "__VITE_ASSET___3Gb0mDZ__"